import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fadeinleft" }

import { storeToRefs } from 'pinia';
import { useMessageCenterStore } from '@/store';
import ChatThread from './components/ChatThread.vue';
import { ChatInterface } from '@/types/MessageCenter';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatList',
  setup(__props) {

const messageCenter = useMessageCenterStore();
const { screen, sortedChats } = storeToRefs(messageCenter);

const openNewChat = () => {
  screen.value = 'new-chat';
};

const getLastMessage = (chat: ChatInterface) => {
  let lastMessage = chat.last_message;
  if (!lastMessage) return '';
  const content = lastMessage?.content;

  if (!content && lastMessage.attachments && lastMessage.attachments.length > 0) {
    let lastAttachment: string = lastMessage.attachments?.[0].name || '';

    if (lastAttachment.startsWith('audio')) {
      return 'Audio Message';
    }
    return lastAttachment;
  }

  return content;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(can)([_unref(PERMISSIONS).CHAT_STORE]))
      ? (_openBlock(), _createBlock(_component_AppButton, {
          key: 0,
          type: "secondary",
          text: "New Message",
          "icon-left": "add",
          "full-width": "",
          onClick: openNewChat
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedChats), (chat) => {
      return (_openBlock(), _createBlock(ChatThread, {
        id: chat.id,
        key: chat.id,
        "last-message": getLastMessage(chat),
        "unread-count": chat.unread_count,
        name: chat.name,
        "updated-at": chat.updated_at
      }, null, 8, ["id", "last-message", "unread-count", "name", "updated-at"]))
    }), 128))
  ]))
}
}

})